import Modal from "../_bootstrapModalExtensions";
import Interfaces from "../_interfaces";

export function ShowAfterLogonPopup() {
    const settingName: string = 'PopupNewsSeen';

    $.ajax({
        url: window.ETDR_RD.appConfig["UrlAction.GetAfterLogonPopupContent"],
        method: "POST",
        success: (data: Interfaces.BaseJsonResponse) => {
            onSuccess(data);
        }
    });

    function onSuccess(data: Interfaces.BaseJsonResponse) {
        let content: string = data.message;
        const contentHash: number = createHash(content);
        const lastSeenInfoHash: number = window.SettingsManager.getAttribute(settingName);
        const alreadySeen: boolean = contentHash === lastSeenInfoHash;

        if (data.success && content && !alreadySeen) {
            Modal.showAlertWindow(
                data.message,
                '',
                'Rendben',
                false,
                () => { window.SettingsManager.setAttribute(settingName, contentHash); }
            )
        }
    }

    function createHash(input: string): number {
        let hash = 0;

        for (let i = 0; i < input.length; i++) {
            hash += input.charCodeAt(i) + i;
        }

        return hash % 2147483647;
    }
}
